import { default as Utils } from '../utils/base.Utils.js';
import { default as Errors } from '../errors/base.Errors.js';

export default class UtilsLocalization {
  constructor() {

  }

  static async loadLocalStrings(name, path) {

    let url = path + name + "_" + (Utils.Language.getUserLanguage().indexOf("-") >= 0 ? Utils.Language.getUserLanguage().substr(0, 2) : Utils.Language.getUserLanguage()) + ".json";

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json; charset=iso-8859-1");

    let options = {
      headers: myHeaders
    };

    try {
      let response = await fetch(url, options);

      let json = await response.json();

      return response.ok ? json : Promise.reject(json);

    } catch (err) {

      return Promise.reject(new Errors.Custom(Errors.Types.STRINGS_ERROR, err));
    }

  }
}
